import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';

import { AuthService } from '../../services/auth.service';

@Component({
  standalone: false,
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent {
  email = '';
  errorMessage = '';
  successMessage = '';
  isSubmitting = false;

  constructor(private readonly authService: AuthService) {
  }

  onSubmit(): void {
    this.errorMessage = '';
    this.successMessage = '';
    this.isSubmitting = true;

    this.authService.requestPasswordReset(this.email).subscribe({
      next: () => {
        this.successMessage = 'If the account exists, a reset link has been sent.';
        this.isSubmitting = false;
      },
      error: (error: HttpErrorResponse) => {
        this.errorMessage = error.error?.message ?? 'Unable to request a reset link';
        this.isSubmitting = false;
      },
    });
  }
}
